import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function SalesFooter() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-dark py-8 text-center" data-id="element-128">
        <div className="container mx-auto px-4 flex flex-col items-center gap-4" data-id="element-129">
          <div className="flex items-center gap-6" data-id="element-130">
            <button onClick={() => setActiveModal('privacy')} className="text-cream/50 hover:text-gold text-sm font-body transition-colors duration-200 underline underline-offset-2 cursor-pointer" data-id="element-131">
              Política de Privacidad
            </button>
            <span className="text-cream/20" data-id="element-132">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-cream/50 hover:text-gold text-sm font-body transition-colors duration-200 underline underline-offset-2 cursor-pointer" data-id="element-133">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-cream/30 text-xs font-body" data-id="element-134">
            © {new Date().getFullYear()} El Protocolo PSL. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-135">
          <div className="bg-cream rounded-lg shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-136">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-8 py-5 border-b border-sage/40 bg-forest" data-id="element-137">
              <h3 className="text-xl font-heading font-bold text-cream" data-id="element-138">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h3>
              <button onClick={() => setActiveModal(null)} className="text-cream/70 hover:text-gold transition-colors duration-200 cursor-pointer" aria-label="Cerrar" data-id="element-139">
                <X className="w-6 h-6" data-id="element-140" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="px-8 py-6 overflow-y-auto text-dark/80 font-body text-sm leading-relaxed space-y-5" data-id="element-141">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-142" /> : <TermsContent data-id="element-143" />}
            </div>

            {/* Modal Footer */}
            <div className="px-8 py-4 border-t border-sage/40 bg-sage/20 text-center" data-id="element-144">
              <button onClick={() => setActiveModal(null)} className="px-8 py-2.5 text-sm font-bold text-forest bg-gold hover:bg-gold/90 transition-colors duration-200 rounded-sm cursor-pointer" data-id="element-145">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-dark/50 italic" data-id="element-146">
        Última actualización: febrero 2026
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-147">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-148">
        Al adquirir El Protocolo PSL, recopilamos únicamente la información
        necesaria para procesar tu compra y entregarte el producto digital: tu
        nombre, dirección de correo electrónico y datos de pago. No almacenamos
        información de tarjetas de crédito en nuestros servidores; todo el
        procesamiento de pagos se realiza a través de plataformas seguras de
        terceros.
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-149">
        2. Uso de la Información
      </h4>
      <p data-id="element-150">
        Utilizamos tu información personal exclusivamente para: (a) procesar y
        entregar tu compra, (b) enviarte el enlace de descarga del protocolo, y
        (c) comunicarnos contigo sobre actualizaciones importantes del producto.
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros con fines de marketing.
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-151">
        3. Protección de Datos
      </h4>
      <p data-id="element-152">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. Esto incluye cifrado SSL en todas
        las transmisiones de datos y almacenamiento seguro de información.
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-153">
        4. Cookies y Tecnologías de Seguimiento
      </h4>
      <p data-id="element-154">
        Nuestro sitio puede utilizar cookies y tecnologías similares para
        mejorar tu experiencia de navegación y analizar el tráfico del sitio.
        Puedes configurar tu navegador para rechazar cookies, aunque esto podría
        afectar la funcionalidad del sitio.
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-155">
        5. Tus Derechos
      </h4>
      <p data-id="element-156">
        Tienes derecho a acceder, corregir o eliminar tu información personal en
        cualquier momento. Para ejercer estos derechos, puedes contactarnos a
        través de los canales oficiales indicados en nuestra página.
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-157">
        6. Cambios a esta Política
      </h4>
      <p data-id="element-158">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Cualquier cambio significativo será comunicado a
        través de nuestro sitio web o por correo electrónico.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-dark/50 italic" data-id="element-159">
        Última actualización: febrero 2026
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-160">
        1. Naturaleza del Producto
      </h4>
      <p data-id="element-161">
        El Protocolo de Sustitución Latina (PSL) es un producto digital
        educativo e informativo. No constituye consejo médico, diagnóstico ni
        tratamiento. El contenido está diseñado con fines educativos y no
        reemplaza la consulta con un profesional de la salud calificado.
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-162">
        2. Descargo de Responsabilidad Médica
      </h4>
      <p data-id="element-163">
        Los resultados pueden variar de persona a persona. Las experiencias
        descritas en nuestro material de marketing son ilustrativas y no
        garantizan resultados específicos. Si tienes una condición médica
        diagnosticada, consulta con tu médico antes de realizar cambios en tu
        alimentación.
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-164">
        3. Entrega del Producto
      </h4>
      <p data-id="element-165">
        Al completar tu compra, recibirás acceso inmediato al producto digital a
        través de un enlace de descarga enviado a tu correo electrónico. Es tu
        responsabilidad proporcionar una dirección de correo electrónico válida
        y verificar tu bandeja de entrada, incluyendo la carpeta de spam.
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-166">
        4. Política de Reembolso
      </h4>
      <p data-id="element-167">
        Debido a la naturaleza digital del producto y su entrega inmediata,
        todas las ventas son finales. Sin embargo, si experimentas problemas
        técnicos con la descarga, nos comprometemos a resolver cualquier
        inconveniente para garantizar que recibas tu producto.
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-168">
        5. Propiedad Intelectual
      </h4>
      <p data-id="element-169">
        Todo el contenido del Protocolo PSL, incluyendo textos, gráficos,
        diseños y metodologías, está protegido por derechos de autor. La compra
        te otorga una licencia personal e intransferible para uso individual.
        Queda prohibida la reproducción, distribución o reventa del material sin
        autorización expresa.
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-170">
        6. Precio Promocional
      </h4>
      <p data-id="element-171">
        El precio de $9.00 USD corresponde a una oferta exclusiva de lanzamiento
        en fase beta, limitada a los primeros 100 compradores. Nos reservamos el
        derecho de modificar el precio en cualquier momento sin previo aviso una
        vez agotadas las plazas disponibles.
      </p>

      <h4 className="font-heading font-bold text-forest text-base" data-id="element-172">
        7. Aceptación de Términos
      </h4>
      <p data-id="element-173">
        Al realizar tu compra, confirmas que has leído, entendido y aceptado
        estos términos y condiciones en su totalidad.
      </p>
    </>;
}